import { Injectable, inject } from '@angular/core';

import { HttpClientPort } from '../../core/http/http-client.port';
import { TaxonomyTerm } from '../../domain/entities/category';
import { Language } from '../../domain/entities/language';
import { CategoryRepository } from '../../domain/repositories/category.repository';
import { toApiLanguage } from '../http/api-language';
import { BOLDEST_ENDPOINTS } from '../http/boldest-endpoints';
import { toTaxonomy } from '../mappers/category.mapper';

@Injectable()
export class HttpCategoryRepository extends CategoryRepository {
  private readonly http = inject(HttpClientPort);

  async findAll(language: Language): Promise<readonly TaxonomyTerm[]> {
    return toTaxonomy(
      await this.http.get({
        path: BOLDEST_ENDPOINTS.categories,
        query: { lang: toApiLanguage(language) },
      }),
    );
  }
}
